import BaseComponent from "components/base-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"

export default class ComponentsCourseGroupsLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    courseGroup: instanceOfClassName("CourseGroup").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, courseGroup, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--course-groups--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || courseGroup.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || courseGroup.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, courseGroup} = this.p

    if (adminLayout) return Routes.adminCourseGroupPath(courseGroup.id())
  }
}
